import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Videos from './components/Videos';
import Lyrics from './components/Lyrics';
import Music from './components/Music';
import Footer from './components/Footer';
import ScrollToTop from './ScrollToTop';
import BeeteLamhe from './components/lyrics/BeeteLamhe';
import BlewUp from './components/lyrics/BlewUp';
import ForeverAlive from './components/lyrics/ForeverAlive';
import FutureSuperstar from './components/lyrics/FutureSuperstar';
import GodsWork from './components/lyrics/GodsWork';
import ISwear from './components/lyrics/ISwear';
import KaunHai from './components/lyrics/KaunHai';
import Legendary from './components/lyrics/Legendary';
import OhMyGaush from './components/lyrics/OhMyGaush';
import OnMyMind from './components/lyrics/OnMyMind';
import Roshni from './components/lyrics/Roshni';
import TwentyTwoFreestyle from './components/lyrics/TwentyTwoFreestyle';
import WoKehtiThi from './components/lyrics/WoKehtiThi';
import XIXFreeverse from './components/lyrics/XIXFreeverse';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Navbar/>
    <Routes>
      <Route exact path="/" element={<Home/>} />
      <Route exact path="/music" element={<Music/>} />
      <Route exact path="/videos" element={<Videos/>} />
      <Route exact path="/lyrics" element={<Lyrics/>} />
      <Route exact path="/lyrics/blew-up" element={<BlewUp/>} />
      <Route exact path="/lyrics/oh-my-gaush" element={<OhMyGaush/>} />
      <Route exact path="/lyrics/i-swear" element={<ISwear/>} />
      <Route exact path="/lyrics/legendary" element={<Legendary/>} />
      <Route exact path="/lyrics/on-my-mind" element={<OnMyMind/>} />
      <Route exact path="/lyrics/kaun-hai" element={<KaunHai/>} />
      <Route exact path="/lyrics/xix-freeverse" element={<XIXFreeverse/>} />
      <Route exact path="/lyrics/gods-work" element={<GodsWork/>} />
      <Route exact path="/lyrics/beete-lamhe" element={<BeeteLamhe/>} />
      <Route exact path="/lyrics/forever-alive" element={<ForeverAlive/>} />
      <Route exact path="/lyrics/future-superstar" element={<FutureSuperstar/>} />
      <Route exact path="/lyrics/roshni" element={<Roshni/>} />
      <Route exact path="/lyrics/22-freestyle" element={<TwentyTwoFreestyle/>} />
      <Route exact path="/lyrics/wo-kehti-thi" element={<WoKehtiThi/>} />
    </Routes>
    <Footer/>
    </BrowserRouter>
  );
}

export default App;
